import { useIsLoggedInWithLoading } from '@dreamstack/auth'
import { PropertySearchContextProvider } from '@dreamstack/feature-components/src/next/PropertySearchContext'
import { SimpleMuiButton } from '@dreamstack/feature-components/src/layout/SimpleMuiButton'
import { SearchProfileForm } from '@dreamstack/feature-components/src/my/searchProfile/SearchProfileForm'
import { useTranslation } from '@dreamstack/i18n'
import { Minus } from '@dreamstack/icons/src/icon-components/Minus'
import { Plus } from '@dreamstack/icons/src/icon-components/Plus'
import type { FunctionComponent } from 'react'
import { useRef, useState } from 'react'

export const SearchProfileFormBlock: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const { isLoggedIn } = useIsLoggedInWithLoading()
  const [showSearchProfileForm, setShowSearchProfileForm] = useState(false)
  const button = useRef<HTMLButtonElement>(null)
  const t = useTranslation()

  return (
    <>
      <div className="pb-px-24">
        <SimpleMuiButton
          ref={button}
          onClick={() => setShowSearchProfileForm(!showSearchProfileForm)}
          variant="text"
          color="primary"
          startIcon={!showSearchProfileForm ? <Plus /> : <Minus />}
        >
          {t('accentro:my.addSearchProfile')}
        </SimpleMuiButton>
      </div>
      {showSearchProfileForm && (
        <PropertySearchContextProvider>
          <SearchProfileForm
            addForAnonymousUser={!isLoggedIn}
            onSaveSearchCallback={() => {
              setShowSearchProfileForm(false)
              button.current?.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center',
              })
            }}
          />
        </PropertySearchContextProvider>
      )}
    </>
  )
}
